<div class="advert-details-right">
  <div class="advert-details-right-main-top">
    <div class="advert-details-right-top">
      <div class="pro-right-title">
        <h2>
          <span>{{ advert.name }}</span>
          @if (advert.user.isVerfied) {
            <img
              src="./assets/images/svg/verified.svg"
              alt="verified"
              class="verify-icon"
              [matTooltip]="verifiedTooltip" />
          }
        </h2>
        <p>
          {{ advert.division?.name
          }}{{ advert.division?.name && advert.area?.name ? ', ' : '' }}
          {{ advert.area?.name
          }}{{ advert.area?.name && advert.zone?.name ? ', ' : '' }}
          {{ advert.zone?.name }}
        </p>
      </div>
      @if (advert.phone || advert.whatsApp) {
        <div class="pro-right-detail">
          <div class="pro-right-title-bottom">
            <h2>Contact</h2>
          </div>
          <div class="phone-number">
            @if (advert.phone) {
              <a href="tel:{{ advert.phone }}">
                <i class="fa-solid fa-phone"></i>
                <span>{{ advert.phone }}</span>
              </a>
            }
            @if (advert.whatsApp) {
              <a href="https://www.whatsapp.com/" target="_blank">
                <i class="fa-brands fa-whatsapp"></i>
                <span>{{ advert.whatsApp }}</span>
              </a>
            }
          </div>
        </div>
      }
    </div>

    <div class="advert-details-right-bottom">
      <div class="pro-right-title-bottom">
        <h2>Oversigt</h2>
      </div>
      <div class="pro-right-detail-two">
        <ul>
          <app-details-item [value]="advert.category?.name" title="Kategori:" />
          <app-details-item [value]="advert.age" title="Alder:" />
          <app-details-item [value]="advert.height" unit="cm" title="Højde:" />
          <app-details-item [value]="advert.weight" unit="kg" title="Vægt:" />
          <app-details-item
            [value]="advert.bodyType?.name"
            title="Kropstype:" />
          <app-details-item
            [value]="advert.orientation?.name"
            title="Orientering:" />
          <app-details-item
            [value]="advert.isGoingOut ? 'Yes' : undefined"
            title="Kører ud:" />
          <app-details-item
            [value]="advert.hairColor?.name"
            title="Hårfarve:" />
          <app-details-item [value]="advert.email" title="Email:" />
          <app-details-item [value]="advert.address" title="Adresse:" />
        </ul>
      </div>
    </div>
  </div>
  <!-- END! advert-details-right-main-top -->

  <div class="advert-details-right-main-bottom">
    <ul>
      <li (click)="onAddToFavorite($event)">
        <i
          class="fa-heart"
          [ngClass]="favoriteId ? 'fa fill' : 'fa-regular'"></i>
        <span>{{
          (!favoriteId
            ? 'ADVERT.ADDED_TO_FAVOURITES'
            : 'ADVERT.REMOVE_FAVOURITES'
          ) | translate
        }}</span>
      </li>
      <li (click)="openReportDialog()">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ 'ADVERT.REPORT_ABUSE' | translate }}</span>
      </li>
    </ul>
  </div>
</div>
